/* Olfinity — synchronise le compteur et le tiroir du panier après un ajout fait hors du thème (blocs Olfinity, quiz, applis). */
(function(){
  if(window.__olfCartSync) return; window.__olfCartSync = true;
  var timer = null;
  function setCount(n){
    document.querySelectorAll('.header__cart-count').forEach(function(w){
      w.setAttribute('data-cart-count', n);
      var spans = w.querySelectorAll('span:not(.visually-hidden)');
      if(spans.length) spans[spans.length - 1].textContent = n > 99 ? '99+' : n;
    });
  }
  function refresh(){
    clearTimeout(timer);
    timer = setTimeout(function(){
      var tc = window.themeCore;
      var done = function(c){ if(c && typeof c.item_count === 'number') setCount(c.item_count); if(tc && tc.EventBus) tc.EventBus.emit('cart:refresh', {}); };
      if(tc && tc.CartApi && tc.CartApi.makeRequest){
        tc.CartApi.makeRequest(tc.CartApi.actions.GET_CART).then(done).catch(function(){});
      } else {
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function(r){ return r.json(); }).then(done).catch(function(){});
      }
    }, 400);
  }
  window.olfCartRefresh = refresh;
  /* Remet en place le compteur du thème si un script l'a écrasé (le thème garde une référence vers ces éléments). */
  function guard(){
    document.querySelectorAll('.header__cart-count').forEach(function(w){
      if(w.__olfGuard) return; w.__olfGuard = true;
      var kids = [].slice.call(w.childNodes);
      var mo = new MutationObserver(function(){
        if(kids.every(function(k){ return w.contains(k); })) return;
        var n = (w.textContent || '').replace(/\D+/g, '') || w.getAttribute('data-cart-count') || '0';
        mo.disconnect();
        while(w.firstChild) w.removeChild(w.firstChild);
        kids.forEach(function(k){ w.appendChild(k); });
        setCount(Number(n));
        mo.observe(w, { childList: true, characterData: true, subtree: true });
      });
      mo.observe(w, { childList: true, characterData: true, subtree: true });
    });
  }
  var of = window.fetch;
  window.fetch = function(input, init){
    var p = of.apply(this, arguments);
    try{
      var url = String(typeof input === 'string' ? input : (input && input.url) || '');
      var body = init && typeof init.body === 'string' ? init.body : '';
      if(/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && body.indexOf('"sections"') === -1){
        p.then(function(r){ if(r && r.ok) refresh(); }).catch(function(){});
      }
    }catch(e){}
    return p;
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guard); else guard();
  document.addEventListener('shopify:section:load', guard);
})();